import styled from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

export default styled.img`
  position: absolute;
  bottom: 0;
  left: 50%;
  display: block;
  z-index: 5;
  width: ${props => props.width}px;
  margin-left: ${(props: { width: number }) => -props.width / 2}px;

  ${media.lessThan('md')`
    display: none;
  `};
`;
